import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { AssignHawkbitFirmware, AssignHawkbitFirmwareVariables } from './__generated__/AssignHawkbitFirmware'

const ASSIGN_HAWKBIT_FIRMWARE = gql`
  mutation AssignHawkbitFirmware($input: AssignHawkbitFirmwareInput!) {
    assignHawkbitFirmware(input: $input) {
      success
    }
  }
`

export const useAssignHawkbitFirmware = () => {
  return useMutation<AssignHawkbitFirmware, AssignHawkbitFirmwareVariables>(ASSIGN_HAWKBIT_FIRMWARE)
}
